<template>
    <section class="endpoint-section endpoint-description">
        <markdown-text class="endpoint-description-text"
                       v-if="description">{{ description }}
        </markdown-text>
        <span v-else class="data-missing">No description available</span>
    </section>
</template>

<script>
  import MarkdownText from '../MarkdownText';

  export default {
    name: 'EndpointDescription',

    components: {
      MarkdownText,
    },

    props: {
      description: {
        type:     String,
        required: false,
      },
    },
  };
</script>

<style scoped>
    .data-missing {
        color: var(--color-gray-medium);
    }
</style>
